// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__ayufL","productName":"Table_productName__j-vYM"};